import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import {
  bootstrapCoreSaga,
  bootstrapErrorSaga,
} from 'affiny-core/modules/bootstrap/saga';
import { EBootstrapActions } from 'affiny-core/modules/bootstrap/types';
import { all, call, takeLatest } from 'redux-saga/effects';

export function* bootstrapAppSaga() {
  try {
    yield call(bootstrapCoreSaga);
  } catch (error) {
    yield call(bootstrapErrorSaga);
    throw error;
  }
}

export function* bootstrapSaga() {
  yield all([
    takeLatest(
      EBootstrapActions.BOOTSTRAP_APP,
      handleAsyncStatus(bootstrapAppSaga, EAsyncEventTypes.BOOTSTRAP_APP)
    ),
  ]);
}
